import { Session } from '@/types/session.types';
import { Post } from '../helpers';

const DuplicateSession = ({
  session,
  projectUuid,
  event,
}: {
  session: Session;
  event: number;
  projectUuid: string;
}): Promise<Session> => {
  return Post({
    path: '/v3/admin/event/session/duplicate',
    body: { session, event, eventUuid: projectUuid },
  });
};

export default DuplicateSession;
